import React, { useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from '../../Components/Reusable/CustomTextArea';
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import RoutesPath from "../../Utils/RoutesPath";
import { toast } from "react-toastify";
import AuthorService from "../../Services/AuthorService";
import BlogService from "../../Services/BlogService";
import Image from "../../Components/Reusable/Image";

const SeoPage = () => {

  const [seoData, setSeoData] = useState({ ...useLocation().state });
  const [uploadedDocuments, setUploadedDocuments] = useState(Array());

  const navigate = useNavigate();

  const Validations = yup.object().shape({
    // title: validationRegex.required,
    // description: validationRegex.required,
    // keywords: validationRegex.required,
    // canonicalurl: validationRegex.required,
    // featuredimage: validationRegex.required,
    // schemacode: validationRegex.required,
    // url: validationRegex.required,
  });

  const {
    register,
    handleSubmit,
    setValue: setValues,
    formState: { errors },
    getValues,
    reset,
  } = useForm({
    // resolver: yupResolver(Validations),
    defaultValues: {
      title: seoData?.metaTitle || "",
      description: seoData?.metaDescription || "",
      keywords: seoData?.metaKeywords || "",
      canonicalurl: seoData?.canonicalURL || "",
      featuredimage: seoData?.altTagFeaturedImage || "",
      schemacode: seoData?.schemaCode || "",
      url: seoData?.url || "",
    },
  });

  const updateBlogSeo = async (seoContent) => {
    console.log(seoContent, "seoContent");

    try {
      const response = await BlogService.updateBlogSeo(
        seoData?.blog_id || "",
        seoContent.title,
        seoContent.description,
        seoContent.keywords,
        seoContent.canonicalurl,
        // seoContent.featuredimage,
        seoContent.featuredimage instanceof FileList ? uploadedDocuments : seoContent.featuredimage,

        seoContent.schemacode,
        seoContent.url,
      );
      toast.success(response.message);
      // navigate(RoutesPath.authors);

    } catch (error) {
      handleApiErrors(error);
      toast.error("Failed to add Seo . Please try again later.");
    }
  };

  useEffect(() => {
    console.log(seoData, 'seoData')
    if (seoData) {
      setValues("metaTitle", seoData?.metaTitle || "");
      setValues("metaDescription", seoData?.metaDescription || "");
      setValues("metaKeywords", seoData?.metaKeywords || "");
      setValues("canonicalURL", seoData?.canonicalURL || "");
      setValues("altTagFeaturedImage", seoData?.altTagFeaturedImage || "");
      setUploadedDocuments(seoData?.altTagFeaturedImage);
      setValues("schemaCode", seoData?.schemaCode || "");
      setValues("url", seoData?.url || "");
      // setValues("image", seoData?.image || "");
    }
  }, [seoData, setValues]);


  const onSubmit = (seoContent) => {
    updateBlogSeo(seoContent);
  };



  return (
    <div>
      <div>
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">SEO</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">SEO</h4>
          </div>
        </div>
        <div className="table_container" style={{ display: "block" }}>
          <div className="table_title">
            <div className="table_headings">
              <h1 className="black fs-18 fw-600 mb-0">
                Edit SEO
              </h1>
            </div>
            <form>
              <div className="row profile_inputs w-100 mt-5">
                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Meta Title"
                    placeholder="File Name"
                    name="title"
                    id="title"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    // showMandatory={true}
                    register={register}
                    setValue={setValues}
                  // showError={errors?.title}
                  // errorMessage={errors?.title?.message}
                  />
                </div>



                <div className="col-md-6">
                  <CustomTextArea
                    labelTitle="Meta Description"
                    placeholder="Meta Description"
                    name="description"
                    id="description"
                    inputType={InputType.text}
                    //   showMandatory={true}
                    additionalClasses="brief"
                    register={register}
                    setValue={setValues}
                  //   showError={errors?.description}
                  //   errorMessage={errors?.description?.message}
                  />
                </div>

                <div className="col-md-6">
                  <CustomTextArea
                    labelTitle="Meta Keywords"
                    placeholder="Meta Keywords"
                    name="keywords"
                    id="keywords"
                    inputType={InputType.text}
                    //   showMandatory={true}
                    additionalClasses="brief"
                    register={register}
                    setValue={setValues}
                  //   showError={errors?.keywords}
                  //   errorMessage={errors?.keywords?.message}
                  />
                </div>

                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="Canonical URL"
                    placeholder="Canonical URL"
                    name="canonicalurl"
                    id="canonicalurl"
                    inputType={InputType.text}
                    //   showMandatory={true}
                    additionalClasses="brief"
                    register={register}
                    setValue={setValues}
                  //   showError={errors?.canonicalurl}
                  //   errorMessage={errors?.canonicalurl?.message}
                  />
                </div>

                {/* <div className="col-md-6">
                  <CustomTextField
                    labelTitle="ALT Tag Featured Image"
                    placeholder="ALT Tag Featured Image"
                    name="featuredimage"
                    id="featuredimage"
                    inputType={InputType.text}
                    //   showMandatory={true}
                    additionalClasses="brief"
                    register={register}
                    setValue={setValues}
                  //   showError={errors?.featuredimage}
                  //   errorMessage={errors?.featuredimage?.message}
                  />
                </div> */}

                <div className="col-md-6 mb-3">
                  <label className="login_heading">ALT Tag Featured Image</label>
                  <div className="position-relative select_file ">

                    <input className="choose-file"

                      type="file"
                      name="featuredimage"
                      id="featuredimage"
                      setValue={setValues}
                      accept="image/*"
                      // placeholder="No file chosen"
                      {...register("featuredimage")}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          const file = e.target.files[0];
                          const validTypes = ["image/jpeg", "image/jpg", "image/webp", "image/png", "image/gif"];
                          if (!validTypes.includes(file.type)) {
                            toast.error("Only JPG, JPEG, WEBP, PNG, and GIF files are allowed.");
                            e.target.value = null; // Clear the input value
                          } else {
                            setUploadedDocuments(file);
                          }
                        }
                      }}
                    />
                    {seoData.altTagFeaturedImage && (
                      <p className="text-success fs-14 fw-400 mt-1">Selected file: {seoData.altTagFeaturedImage}</p>
                    )}
                  </div>

                </div>

                <div className="col-md-6">
                  <CustomTextArea
                    labelTitle="Schema Code"
                    placeholder="Schema Code"
                    name="schemacode"
                    id="schemacode"
                    inputType={InputType.text}
                    //   showMandatory={true}
                    additionalClasses="brief"
                    register={register}
                    setValue={setValues}

                  //   showError={errors?.schemacode}
                  //   errorMessage={errors?.schemacode?.message}
                  />
                </div>

                <div className="col-md-6">
                  <CustomTextField
                    labelTitle="URL"
                    placeholder="URL"
                    name="url"
                    id="url"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    // showMandatory={false}
                    register={register}
                    setValue={setValues}
                    defaultValues={seoData.url}
                  // showError={errors?.url}
                  // errorMessage={errors?.url?.message}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <ButtonWithIcon
                    text={"Update"}
                    icon={SvgImages.tick_mark}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
                <div>
                <a className="back_login m-0 cursor-pointer justify-content-start" onClick={() => window.history.back()}>
                  <Image src={SvgImages.back_arrow_login} className="m-0" />
                  Back
                </a>
                </div>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeoPage;
